/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  titleVytvoreni: {
    id: "b2b.projekt-vytvoreni.title.vytvoreni",
    defaultMessage: "New project"
  },
  titleEdit: {
    id: "b2b.projekt-vytvoreni.title.edit",
    defaultMessage: "Edit project"
  },
  saveDialogTitle: {
    id: "b2b.projekt-vytvoreni.save-dialog.title",
    defaultMessage: "Save project"
  },
  buttonSubmitVytvoreni: {
    id: "b2b.projekt-vytvoreni.button.submit-vytvoreni",
    defaultMessage: "Create"
  },
  buttonSubmitEdit: {
    id: "b2b.projekt-vytvoreni.button.submit-edit",
    defaultMessage: "Save"
  },
  buttonCancel: {
    id: "b2b.projekt-vytvoreni.button.cancel",
    defaultMessage: "Cancel"
  },
  nazevLabel: {
    id: "b2b.projekt-vytvoreni.field.nazev.label",
    defaultMessage: "Name"
  },
  nazevEnLabel: {
    id: "b2b.projekt-vytvoreni.field.nazevEn.label",
    defaultMessage: "Name (EN)"
  },
  popisLabel: {
    id: "b2b.projekt-vytvoreni.field.popis.label",
    defaultMessage: "Description"
  },
  popisEnLabel: {
    id: "b2b.projekt-vytvoreni.field.popisEn.label",
    defaultMessage: "Description (EN)"
  }
});

export default () => useMessages(MESSAGES);
